/**
 * GlobalLoadingManager - Global loading indicator component
 * 
 * Features:
 * - Single source of truth for global loading state
 * - Debounced show/hide (200ms show delay, 150ms hide fade)
 * - Prevents double-loading indicators
 * - Smooth fade transitions
 * 
 * Usage:
 * Add <GlobalLoadingManager /> to your App component
 */

import React, { useEffect } from 'react';
import { useGlobalLoading } from '../utils/loadingManager';
import { useLocation } from 'react-router-dom';
import { useGlobalLoadingControl } from '../utils/loadingManager';

export function GlobalLoadingManager() {
  const { isLoading, message } = useGlobalLoading();
  const { hide } = useGlobalLoadingControl();
  const location = useLocation();

  // Hide loading when route changes complete
  useEffect(() => {
    // Hide loading after a short delay to allow route transition
    const timer = setTimeout(() => {
      hide();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, hide]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center pointer-events-none">
      <div className="theme-card-bg rounded-lg p-6 shadow-lg theme-card-border pointer-events-auto">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 border-2 border-[#9c68f2] border-t-transparent rounded-full animate-spin" />
          <div>
            <p className="theme-text-primary font-medium text-sm">
              {message || 'Loading...'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

